import React from 'react';

export function NativeScrollArea({ children }) {
  return <>{children}</>;
}
